import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import '../../content/css/CategoryOptionEditControl.css';

export default class RiskTypeDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            risk: this.props.risk
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.risk !== this.props.risk) this.setState({ risk: this.props.risk });
    }

    handleSelect = (risk) => {
        this.setState({ risk });
        this.props.onChange(risk);
    }

    getName(risk) {
        switch (risk) {
            case 0: return "Low";
            case 1: return "Medium";
            case 2: return "High";
            default: return "Medium";
        }
    }

    getColor(risk) {
        switch (risk) {
            case 0: return "risk-0";
            case 1: return "risk-1";
            case 2: return "risk-2";
            default: return "risk-1";
        }
    }

    render() {
        return (
            <DropdownButton title={this.getName(this.state.risk)} id={`dropdown-risk`} className={this.getColor(this.state.risk)} >
                <MenuItem eventKey="1" active={this.state.risk === 0} onSelect={() => this.handleSelect(0)}>{this.getName(0)}</MenuItem>
                <MenuItem eventKey="2" active={this.state.risk === 1} onSelect={() => this.handleSelect(1)}>{this.getName(1)}</MenuItem>
                <MenuItem eventKey="3" active={this.state.risk === 2} onSelect={() => this.handleSelect(2)}>{this.getName(2)}</MenuItem>
            </DropdownButton>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/RiskTypeDropdown.js